import { render, staticRenderFns } from "./AccountContainer.vue?vue&type=template&id=64eb21a6&scoped=true&lang=html"
import script from "./AccountContainer.vue?vue&type=script&lang=js"
export * from "./AccountContainer.vue?vue&type=script&lang=js"
import style0 from "./AccountContainer.vue?vue&type=style&index=0&id=64eb21a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eb21a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64eb21a6')) {
      api.createRecord('64eb21a6', component.options)
    } else {
      api.reload('64eb21a6', component.options)
    }
    module.hot.accept("./AccountContainer.vue?vue&type=template&id=64eb21a6&scoped=true&lang=html", function () {
      api.rerender('64eb21a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/AccountContainer.vue"
export default component.exports